import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { X, Sparkles } from "lucide-react";

export default function ProductPicker({ value, onChange, suggestFrom }) {
  const [q, setQ] = useState("");
  const [hits, setHits] = useState([]);
  useEffect(() => {
    const t = setTimeout(() => {
      if (q.trim().length < 2) return setHits([]);
      api.get("/admin/cms/product-search", { params: { q } }).then((r) => setHits(r.data.items));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);
  const add = (p) => { if (!value.some((v) => v.id === p.id)) onChange([...value, p]); };
  const suggest = async () => { const r = await api.post("/admin/cms/suggest-products", suggestFrom()); r.data.items.forEach(add); onChange([...value, ...r.data.items.filter((p) => !value.some((v) => v.id === p.id))]); };
  return (
    <div className="space-y-2" data-testid="product-picker">
      <div className="flex flex-wrap gap-1.5">
        {value.map((p) => (
          <span key={p.id} className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2.5 py-1 text-xs" data-testid={`picked-${p.id}`}>
            {p.name?.slice(0, 50)}<button type="button" onClick={() => onChange(value.filter((v) => v.id !== p.id))}><X size={12} /></button></span>))}
      </div>
      <div className="flex gap-2">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search products by name or SKU" className="h-9" data-testid="product-picker-search" />
        {suggestFrom && <Button type="button" variant="outline" className="h-9 shrink-0" onClick={suggest} data-testid="product-picker-suggest"><Sparkles size={14} className="mr-1" />Suggest</Button>}
      </div>
      {hits.length > 0 && <div className="rounded-lg border bg-white max-h-48 overflow-auto divide-y">
        {hits.map((p) => <button type="button" key={p.id} onClick={() => { add(p); setQ(""); }} className="w-full text-left px-3 py-1.5 text-xs hover:bg-slate-50" data-testid={`product-hit-${p.id}`}>{p.name} <span className="text-slate-400">{p.sku}</span></button>)}
      </div>}
    </div>
  );
}

export function FaqEditor({ value, onChange }) {
  const set = (i, k, v) => onChange(value.map((f, j) => (j === i ? { ...f, [k]: v } : f)));
  return (
    <div className="space-y-2" data-testid="faq-editor">
      {value.map((f, i) => (
        <div key={i} className="rounded-lg border p-2 space-y-1.5">
          <div className="flex gap-2"><Input value={f.q} onChange={(e) => set(i, "q", e.target.value)} placeholder="Question" className="h-8" data-testid={`faq-q-${i}`} />
            <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))} className="text-red-600"><X size={15} /></button></div>
          <textarea value={f.a} onChange={(e) => set(i, "a", e.target.value)} rows={2} placeholder="Answer" className="w-full rounded-md border px-2 py-1 text-sm" data-testid={`faq-a-${i}`} />
        </div>))}
      <Button type="button" variant="outline" size="sm" onClick={() => onChange([...value, { q: "", a: "" }])} data-testid="faq-add">Add question</Button>
    </div>
  );
}
